<template>
    <div id="permitAdjust" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="permitAdjustHeader">Asset Permit Adjust</span>
                    <button type="submit" class="btn btn-tertiary pull-right" v-on:click.prevent="BackAssetPermitList">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-permit-adjust">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="permitAdjustForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="unit_no">#Unit:&nbsp;&nbsp;</label>
                                        <span class="label">{{unit_no}}</span>
                                    </div>
                                    <div class="col form-group mt-4" v-if="customer != ''">
                                        <label class="control-label" for="customer">Customer:&nbsp;&nbsp;</label>
                                        <span class="label">{{customer}}</span>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="permit_no">#Permit:&nbsp;&nbsp;</label>
                                        <span class="label">{{permit_no}}</span>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="permit_desc">Description:&nbsp;&nbsp;</label>
                                        <span class="label">{{permit_desc}}</span>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="effective_date">Effective Date:&nbsp;&nbsp;</label>
                                        <span class="label">{{effective_date}}</span>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="expiry_date">Expiry Date:&nbsp;&nbsp;</label>
                                        <span class="label">{{expiry_date}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="expiry_date">Adjustment Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="adjustment_date" name="adjustment_date" v-model="adjustment_date" :config="optionsDate"></date-picker>
                                            <label for="adjustment_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ adjustment_date_error_msg }}</div>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="billback_allowance">Billback Allowance:&nbsp;&nbsp;</label>
                                        <span class="label">{{amountFormat(billback_allowance)}}</span>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="amortized_amount">Amortized Amount:&nbsp;&nbsp;</label>
                                        <span class="label">{{amountFormat(amortized_amount)}}</span>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="old_permit_amount">Old Permit Amount:&nbsp;&nbsp;</label>
                                        <span class="label">{{amountFormat(old_permit_amount)}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="new_permit_amount">New Permit Amount:</label>
                                        <input type="text" class="form-control" v-model="new_permit_amount" id="new_permit_amount" placeholder="Enter New Permit Amount" name="new_permit_amount" @keypress="validateAmount($event)" @input="permitDifference($event)">
                                        <div class="field-error">{{new_permit_amount_error_msg}}</div>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="permit_difference">Difference:&nbsp;&nbsp;</label>
                                        <span class="label">{{amountFormat(permit_difference)}}</span>
                                    </div>
                                    <div class="col form-group mt-4" v-if="billBackAmountFound">
                                        <label class="control-label" for="new_billback_amount">Customer Billback Amount:&nbsp;&nbsp;</label>
                                        <span class="label">{{amountFormat(new_billback_amount)}}</span>
                                    </div>
                                </div>
                                <div class="btn-groups text-left" v-if="showCalculateBtn">
                                    <button type="submit" class="btn btn-tertiary" v-on:click.prevent="customerBillBackAmount">Customer Billback</button>    
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="UpdatePermitAmountBtn" class="btn btn-primary" v-on:click.prevent="updatePermitAmount" :disabled="disableUpdateBtn">
                                        <i class="fp-reload"> </i> Update
                                    </button>
                                    <button type="submit" id="CancelPermitAmountBtn" class="btn btn-tertiary" v-on:click.prevent="BackAssetPermitList">
                                        <i class="fp-close"> </i> Cancel
                                    </button>
                                </div>
                            </form>    
                        </section>
                    </div>                
                </div>    
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>        
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import moment from 'moment';

export default {
    name: "PermitAdjust",
    metaInfo() {
        return {
            title: "Asset Permit Adjust | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        permitId:0,
        unit_no:"",
        customer:"",
        customer_id:null,
        permit_no:"",
        permit_desc:"",
        effective_date:"",
        expiry_date:"",
        adjustment_date:"",
        billback_allowance:0,
        amortized_amount:0,
        old_permit_amount:0,
        new_permit_amount:"",
        permit_difference:0,
        old_billback_amount:0,
        new_billback_amount:"",
        billback_difference:0,
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        adjustment_date_error_msg:"",
        new_permit_amount_error_msg:"",
        new_billback_amount_error_msg:"",
        reservation_details:[],
        vehicle_id:null,
        showCalculateBtn:false,
        billBackAmountFound:false,
        disableUpdateBtn:false
    }),
    watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_permit') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.permitId = self.$route.params.id;
        var todayDate = self.getTodayDate();
        // self.optionsDate.maxDate = moment(todayDate,"MM/DD/YYYY");
        self.optionsDate.maxDate = self.adjustment_date = moment(todayDate).format("MM/DD/YYYY");
        setTimeout(function () {
            self.loadPermitData();
        }, 100);
    },
    methods: {
        BackAssetPermitList() {
            var self = this;
            self.$router.push("/vehiclepermit/list");
        },
        loadPermitData() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/permit/adjust/" + self.permitId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    
                    if (data.status == "success") {
                        self.unit_no = data.content.unit_no;
                        if (data.content.customer_id != null) {
                            self.customer = data.content.custCode + " | " + data.content.custName;
                            self.customer_id = data.content.customer_id;
                            self.showCalculateBtn = true;
                            self.disableUpdateBtn = true;
                        }else{
                            self.customer = "";
                            self.customer_id = null;
                        }
                        self.permit_no = data.content.permit_number;
                        self.permit_desc = data.content.description;
                        self.effective_date = data.content.effective_date;
                        self.expiry_date = data.content.expiry_date;
                        self.old_permit_amount = data.content.amount;
                        self.old_billback_amount = data.content.permit_bill_back_amount;
                        self.amortized_amount = data.content.permit_amortized_amount;
                        self.reservation_details = data.content.reservation_details;
                        self.vehicle_id = data.content.vehicle_id;
                        if (data.content.billback_allowance != undefined && data.content.billback_allowance != null) {
                            self.billback_allowance = data.content.billback_allowance;
                        }
                    } 
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'permit-adjustment-data');
                }
            });
        },
        updatePermitAmount() {
            var self = this;
            var error = false;
            self.adjustment_date_error_msg = "";
            self.new_permit_amount_error_msg = "";
            self.new_billback_amount_error_msg = "";
            
            if (!self.adjustment_date || self.adjustment_date == null || self.adjustment_date == "") {
                self.adjustment_date_error_msg = "Adjustment Date Required.";
                error = true;
            }

            if ( self.effective_date != null && self.expiry_date != null && self.effective_date != "" && self.expiry_date != "" && self.adjustment_date!= null && self.adjustment_date != "" ) {
                var effectiveDate = Date.parse(self.effective_date);
                var expiryDate = Date.parse(self.expiry_date);
                var adjustmentDate = Date.parse(self.adjustment_date);
                
                if( adjustmentDate <= effectiveDate || adjustmentDate >= expiryDate ) {
                    self.adjustment_date_error_msg = "Adjustment Date Must Be Between Effective Date and Expiry Date.";
                    error = true;
                }
            }

            if (String(self.new_permit_amount) == "") {
                self.new_permit_amount_error_msg = "New Permit Amount Required.";
                error = true;
            }

            // if (self.customer != "") {
            //     if (String(self.new_billback_amount) == "") {
            //         self.new_billback_amount_error_msg = "New Billback Amount Required.";
            //         error = true;
            //     }
            // }

            if (!error) {

                self.loading = true;

                $("#UpdatePermitAmountBtn").val("Updating ...");
                $("#UpdatePermitAmountBtn").prop("disabled", true);
                $("#CancelPermitAmountBtn").prop("disabled", true);

                var fields = $("#permitAdjustForm").serializeArray();
                fields.push({name: "id", value: self.permitId});
                if (self.customer_id != null) {
                    if (self.billBackAmountFound) {
                        fields.push({name: "reservation_details", value: JSON.stringify(self.reservation_details)});
                        // fields.push({name: "invoice_amount", value: self.permit_difference});
                        fields.push({name: "invoice_amount", value: self.new_billback_amount});
                        fields.push({name: "customer_found", value: 1});
                        fields.push({name: "customer_id", value: self.customer_id});  
                    }else{
                        fields.push({name: "customer_found", value: 0});   
                    }
                          
                }else{
                    fields.push({name: "customer_found", value: 0});
                }
                console.log(fields);

                $.ajax({
                    url: process.env.ROOT_API + "/permit-amount/update",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $("#UpdatePermitAmountBtn").val("Update");
                        $("#UpdatePermitAmountBtn").prop("disabled", false);
                        $("#CancelPermitAmountBtn").prop("disabled", false);
                        
                        if (data.status == "success") {

                            if (data.content.invoice_id != undefined && data.content.invoice_id != null) {
                                var invoiceId = data.content.invoice_id;
                                self.$router.push("/invoice/permit/" + invoiceId + "?from=permit");
                            }else{
                                self.$router.push("/vehiclepermit/list");
                            }

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                    self.common_error_msg += data.content[i] + "\n";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $("#UpdatePermitAmountBtn").val("Update");
                        $("#UpdatePermitAmountBtn").prop("disabled", false);
                        $("#CancelPermitAmountBtn").prop("disabled", false);
                        self.generateStatusCodeMessage(jqXHR,false,'update-permit-amount');
                    }
                });
            }
        },
        validateAmount: function (evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
                    '.') != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        
        permitDifference($event) {
            var self = this;
            if (String(self.new_permit_amount) != "") {
                self.permit_difference = self.old_permit_amount - self.new_permit_amount; //old permit amount - new permit amount         
            }else{
                self.permit_difference = 0;
            }
            if (self.old_permit_amount > self.new_permit_amount) {
                self.permit_difference = -self.permit_difference; //old permit greater then difference in minus
            }else if (self.new_permit_amount > self.old_permit_amount) {
                self.permit_difference = -self.permit_difference; //new permit greater then difference in plus
            }

            // if (self.customer != "") {
            //     self.new_billback_amount = self.new_permit_amount;
            //     self.billback_difference = self.permit_difference;
            // }
        },
        billbackDifference($event) {
            var self = this;
            if (self.customer == "") {
                if (String(self.new_billback_amount) != "") {
                    self.billback_difference = self.old_billback_amount - self.new_billback_amount;                
                }else{
                    self.billback_difference = 0;
                }
            }
        },
        customerBillBackAmount() {
            var self = this;
            var error = false;
            self.adjustment_date_error_msg = "";
            self.new_permit_amount_error_msg = "";
            
            if (!self.adjustment_date || self.adjustment_date == null || self.adjustment_date == "") {
                self.adjustment_date_error_msg = "Adjustment Date Required.";
                error = true;
            }

            if ( self.effective_date != null && self.expiry_date != null && self.effective_date != "" && self.expiry_date != "" && self.adjustment_date!= null && self.adjustment_date != "" ) {
                var effectiveDate = Date.parse(self.effective_date);
                var expiryDate = Date.parse(self.expiry_date);
                var adjustmentDate = Date.parse(self.adjustment_date);
                
                if( adjustmentDate <= effectiveDate || adjustmentDate >= expiryDate ) {
                    self.adjustment_date_error_msg = "Adjustment Date Must Be Between Effective Date and Expiry Date.";
                    error = true;
                }
            }

            if (String(self.new_permit_amount) == "") {
                self.new_permit_amount_error_msg = "New Permit Amount Required.";
                error = true;
            }
            
            if (!error) {

                self.loading = true;
                if (self.reservation_details[0] != undefined) {
                    var fields = {
                        customer_id:self.customer_id,
                        adjustment_date:self.adjustment_date,
                        id:self.permitId,
                        new_permit_amount:self.new_permit_amount,
                        vehicle_id:self.vehicle_id ,
                        billback_effective_date:self.reservation_details[0].from_date,
                        billback_expiry_date:self.reservation_details[0].to_date
                    }
                }else{
                    var fields = {
                        customer_id:self.customer_id,
                        adjustment_date:self.adjustment_date,
                        id:self.permitId,
                        new_permit_amount:self.new_permit_amount,
                        vehicle_id:self.vehicle_id    
                    }
                }

                $.ajax({
                    url: process.env.ROOT_API + "/permit/customer-billback",
                    type: "POST",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType:"json",
                    data:fields,
                    success: function (data) {
                        self.loading = false;
                        self.disableUpdateBtn = false;
                        if (data.status == 'success') {
                            
                            if (data.content.customer_found == 1) {

                                self.new_billback_amount = data.content.new_bill_back_amount;
                                self.customer_id = data.content.customer_id;
                                self.billBackAmountFound = true;
                            }else{
                                
                                self.billBackAmountFound = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'permit-customer-billback')
                    }
                });
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/PermitAdjust.vue